let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9TyqT")).then(() => parcelRequire('6kz4R'));